<script lang="ts">
  import type { EditorGroup } from '../types';

  let {
    group,
    onEdit,
    onDelete,
  }: {
    group: EditorGroup;
    onEdit?: (group: EditorGroup) => void;
    onDelete?: (group: EditorGroup) => void;
  } = $props();

  function handleEdit(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    onEdit?.(group);
  }

  function handleDelete(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    onDelete?.(group);
  }
</script>

<div class="flex items-center justify-between gap-3">
  <div>
    <div class="text-sm font-semibold text-gray-900">
      {group.emoji ? `${group.emoji} ${group.title}` : group.title}
    </div>
    <div class="mt-1 text-[11px] uppercase tracking-wide text-gray-500">
      {group.visibility === 'public' ? '전체 공개' : group.visibility === 'internal' ? '내부 공개' : group.visibility} · {group.position + 1}번째
    </div>
  </div>
  <div class="flex items-center gap-1">
    <button
      type="button"
      class="rounded-xl border border-gray-200 px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-white"
      onclick={handleEdit}
    >
      편집
    </button>
    <button
      type="button"
      class="rounded-xl border border-red-200 px-2.5 py-1.5 text-xs font-medium text-red-600 hover:bg-red-50"
      onclick={handleDelete}
    >
      삭제
    </button>
  </div>
</div>
